import { render, staticRenderFns } from "./yuebaozhuang.vue?vue&type=template&id=478896ee&scoped=true&"
import script from "./yuebaozhuang.vue?vue&type=script&lang=js&"
export * from "./yuebaozhuang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478896ee",
  null
  
)

export default component.exports